// extracted by mini-css-extract-plugin
export default {"primaryOrangeButton":"Txv4heynTqHBopNER19vD","secondaryOrangeButton":"_1QjZZBOzav6sBArrFyyQaw"};